var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4276",
    "data-name": "Group 4276",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 468.803,
    height: 291.726,
    viewBox: "0 0 468.803 291.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3613",
    "data-name": "Rectangle 3613",
    width: 468.803,
    height: 291.726,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7732",
    "data-name": "Path 7732",
    d: "M333.672,322.327H254.927l16.143-73.636h46.46Z",
    transform: "translate(-254.927 -248.691)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.748,
    y1: 1.095,
    x2: -2.737,
    y2: 1.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151a43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#000320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21306d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7733",
    "data-name": "Path 7733",
    d: "M223.064,326.239a14.841,14.841,0,0,0-14.842,14.841H366.245A14.842,14.842,0,0,0,351.4,326.239Z",
    transform: "translate(-208.222 -326.239)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.118,
    y1: 1,
    x2: -1.113,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151a43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21306d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2891",
    "data-name": "Rectangle 2891",
    width: 347.039,
    height: 254.607,
    rx: 45.701,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.237,
    y1: 1.146,
    x2: -0.234,
    y2: 1.146,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3016",
    "data-name": "Rectangle 3016",
    width: 202.49,
    height: 70.441,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M20.7,236.8a5.637,5.637,0,0,0,4,1.656H215.882a5.653,5.653,0,0,0,5.654-5.654V173.668a5.653,5.653,0,0,0-5.654-5.654H24.7a5.655,5.655,0,0,0-5.654,5.654V232.8a5.638,5.638,0,0,0,1.657,4",
    transform: "translate(-19.046 -168.014)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 240 85"
  }, /*#__PURE__*/React.createElement("image", {
    width: 240,
    height: 85,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAABVCAYAAAB3hGnPAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAA8KADAAQAAAABAAAAVQAAAABO5xgXAAAglElEQVR4Ae1di4LjqK7sPPr8/yfd79ppJ7eqJGGBIY7T6ZnZc2A3AYReyJQFTjpzut/vH7PMCMwI/DsjcHW3+ygGuG95pGrfPwT+0+kDjY8P1Lfl/nE+m0bKtTeH0wd420JS6PU2NLdcm35X14YrEVz3Db7S5d9RDvv4TqfSHG/VRTQj/y0x4FopcR7MeW+uRf6Z+MNGxHOkt6vP5UJGPPTXoKMVf3b/ebnO7HCtBqDQ1XgocF8DwNaFwAIQUvB2Y3WTswQi/v+4Q7PRaJjgBpF8lL4tFdgpQ0BntNA2dWSaGca7O2h2pbGGu4SNHjLRg+hamgmWATJB4EYDKKcOX6VHXOtb19Y6XFqKifd6NgrjTqP40vFzR7QexnVYHMCtqvCvvdHWCr7fCzvf1oQJlLg8UuZzbudLkfCFIGzHY6ynuoxxXeMVhfRe/Ap/MKImH+knyrN2xJ7dkfPlXPy7fLIN0F4uAq7GwH8GoC8XDLgMdMmZOyd0X2662DfUpAuAADFBTac5TlppkwY5TQhqBE7BGdnYx6hnnW6aTdPkhcl8bb9hP971RWy3sePiRSL0FMIPN/wid600vrTx41ztpptHVk19KtbGyvJ0q7dgnxZ+ktHXasXds9vyYQkDCavYaH49XZQKfRzXesaaFoAsFxTdWW/WFfLhAQEb4CXtAuASoLzUzLjMvif2UV8AYIKZY5crwEyQC8SgAcglA/NCfwGcQLIAe2dGJVgJ6i8C+vbxhXohuPFiG9MxXkxI2wpfEQHecPhRbQnRQc7AoPAO06zNsYrOKhTJdcVdQdeQAfI711jh7x9pL3D2gHPhVLT+uEI68y38HG8K42g31nrgUBgOMa92EmZEjPVeOOIaUX+0y+BO44FPXJ8M0yYcSSY1iyFdhza+iZGgk276Cnql3/lYVfEOeZ8fdUTG5RBBeDohq16tNtCi/wmwEsDX5eOyAMQALqaFPvGBoyqNA8gFwASrwOsg5VZz+bUIvGp/oQ0NorFmkLA6CG4W9hky6aCzeNGxTQE9FmzUFQ9m9TTIPNiqdJvdXwcMyk+U7lzckF+7nzC7r5Px7t0NY2ENNPSGe/MofGhwcb+lFKWvaeMa5JqorjR0sp+vky+fmi9MDnygbhXXF+yss+5qDVMX5SijF5oAH8l8uzDrXplxbXvMsSuzLvv/uX58Xm8Yv3xccR1tt3uRPO/qBmCBiqBkRkUtECMDA7S/2CZ4BWYDNPvMwLxgPF8xS1sGBg1RiYlYyGyKBrIVvO2EjYvzGQPYdK+LJC5AyKruEp0DAYu7XyUz6HAeQ3XDgYGy30BmfLaFN9otNRZPD9wag4iu6VZ0pQTjSrFW35GW6/X+wC7xwFJAZl17j9gEUx7bayd7VbyoK/S6Dqnv2SAf6MzAWuMErbdZnz+v6jPTXgDm5YsgvghLd2Tgq8eUoF7ON2TlBanYt9C8Oejcy20zOsvXl0CrLfM/BCuA/OtLd/Ivz8pf6Me5mTICMRe8LxbdBWNypJcgra1CioYP5btX3AyCZbdOi6dnqd0V8Gjwk6XnQwrGa6bTHFsFMZu89+kl4FbuT/Z5FKtKdAMI0Xcmy69JAgCr5ttOOPQkkVebEfqNyg0BFuh30NGO3R/Xt8ALMKqNbHtFEuT59kbwErAEr6vIGDDwXwFiAB0Xu2yh9aCK2RYA/fUPAQng/rqh/Qu1Z14YUVt9A7CBF5kbgGbhBHUGBq/tWUQevtFJCa0VdxWvFyn0G2NEm7pd4ygDx/jLhpOtZ3Rs7O3Ik/9wWBhI6N1R/Yy7P8KTF2ZlwBfA4fm6kqFejkP3Rm8K0Oa6NPzKwBsFq/ccqnRQXvpB5ZESDCuAfft8A3CBRm6jdd698poxGULGlZ1Oi8R1Fv7Fh1tn8NwMwGRmNtUWGiBewctMzIxswGUmvqn/pay8AODMtLalRkp3e8rm9Hed19qiY+yleh20Vn5C146Vvk8sdBU6GlA9LE/pztKPlNFWxeudmHg1aGORIUMsZ46gva321fTSLsNBlH3BU43Hwc3M3t5k1w7PS6Tkn/wKJVxXfs1GjzuqBO3X6tnrELKVblzn6rpCZ08fgasbCOrIwDdsh/nE+YrXeQEoP/2BcMyHtftI+YVAx0MsgpuYXc/ABCKyrs7AqH/9A/AqCy8f/3Abjf6dfZ5/0VYmRp8PvwhgAy0V23lYQaTDGQCYaAQ3+xftWO/aJgTR6xir5LPuhn/UjSBWfjXMYauQk512zGNbWP+aBmPPAt+rmBm1+17mAtlnZbqKRsTwaTQ+oBe/BuOZ/G2/Oz6G/UO6sx5fP3pwBWd1DuYWmGdg1si8H8jCl7udeS/IwFk85qez8i/yX5RUeW3LFto+MrIHUsysBDJByhczMl/KtA5eApl9vRzEOvcCwPS3mqxPgI5U9PDsN9ThQi8wbzffovztBmqF2VxZbM7CvmIeE49A1Coe90L2MdffM7o3x+/MZ6R7R6euC7MtokTQntG+8eEVPuclYHiNqPoc+ht9BP3Cj1cJXuLxdtFHrQIwMAdhZs7IwotvjZFdmVEBZmVW1OQRUNn27bUUsu982le6U3tXNfw1vliKsQz3pJ8Zt8AEpzJwdH60jrl830gdo319+drHlm9f6s9y0Oej82w9foeOVue7+romC59AQ6PACxCjY+dcfM5LQ1gyutmmpRM7xtMZnwcD7NolfwG8vLAIWMnA8SUNbYmVUQ3MBCmByRcfVLH/xTZediaODE1A4xxMP6CYF0POiDJ48ysmf5PT4v4mhl31xrACuKH+IKGdV2NqZ7jhrrvPhMhie8DKGwI08qvrRXuhDtjv2RmuuY7eLF/FqeENvkp3w8MrQ752jqJxjuCniI6HN56BsdtNOqT7fl3lnXfhNhtt7LA/vs5fejptiRIYizNwPDXW57raFhOgBKExkU6Aa5vtGdm2zjV4pZiTgGLJtheHs0zFhtspBwOnfqT09bRUhOOI0jfwIhYvaHmXlzuXwDx7wtgjlu78usQUiEcKj7MVic18k53UtGuSfcyD0NZ0pb/oToNsFjVs+FhiQbYUfgVeKuJZ9k5gYivNTHfH2ZflC0+a8YUsFQKdD7i0y8UDrosyLrGFHTATLPp8cFYyMEFMgAp8GNS2WKDFOZh7bgCbNZ9Is80MzNradnYWgOUQ9dA399x80vs6WW8VQmJCM92c6gH0KpGqs2HdEnJkt6PfppSLDE0/bOo5X7NDSeLeBHjk6yi89tFIUthptjY6LO+Pkc83bOd5cS7Z7+ChX5mv56doXNuIW/BmfaErxrIOZVeX41mWT83vd2RhKMD7xwlYiq2y9rCgMzsTa2dsnfl02nbGxB220fi+hkAAPgHYHj4RtLY1Ll/MiD5By8xL1BPEpBO8qPOLdN5RYn8ux/NM0OakN6WzyDShhlGyHd6Gbb/bLN59gcRxwH53rknVb2nCieIHVldvgdGP4DkwvaGykY3efMNub+wVGv3Pl5dZqkyObXeu9fGIH9IZeqEo6+rpIa2sZwAXdwFkV37QROAiIxOsxA6LXwBmaX42vAC8Z+BvueAMzM+LmYnFZw+L1wyMgdgyC5QErWdcglVbaNH87FvAC+A7/YY7w7p9pjN17B5+HtnMnBMrpNIw37/1nqPdKnqnnVb37P/PRkBrGW8Esb7LAayetEXlN7G46ABOrEtCmDwlWTJhgi9wGYAgxg3u6SEWo0tGAlxnYrYFUgelMrBlYdtm29NobrX1hFp7c45Tj90dehmYdnrlCG9PftJmBP7KCBC0Sgz8bJdtPn0GgRkWiMSxFwVABnB4Er7hAdcJL8OQIVU75IJHYIz6hNUAMDrVPoDj4IoHWQuZ0TeaAbdsnQXsGJNm3QioUncONqJgAt2SechAvpbWFZzEGYG/PALEDZYzYIkafwYI0PJ8ewaQuc4DI8QWcKvPgUlDdx3zdpkpxpnAiRHbQlMhXus+HQz8j4rwYItglQGC1bfO7Ms4FMWZOTIvNFO3jSf8ili88AYZYbsqJlyR/u2dHIY8l2bmeeht7T9pm5Og/d8xz7cFrFXE9ck1eaTEmtZahqAHgA+vGBEgCd+8CgCb+gJmyETWFc3tFg+EVSMKwLSlr3cFIzgJ0OI0FeLFrTUL382Y1Sst6AZgyrsIWcalw0T9LOWmwk7is1ES+6WSa1hCd0M+1LXLcEiky7w3j65QQ3x1ru+w3bgy7D5j69E8horzANZHtlP0cd04oPK1L+NZR6+d1l0epq6hjo0Mnz0bYIlmukN5stFr80udssy5xgh8c90TrAnKDT4G8wzMw7RoAomyK7KtGWCNMbMkmhGMJPMOdvFHZqYvEnS9rmLt9VvhR4i2OvpSW+pjOU4oSkyc/UyP8X69z5n19nW8i/raXLP1/dkY98/O6fE8sr/9dlrbYqj0xYJKotV4oscaTKRY8pmkdtbRk1sFGDvE2UPNTCyX+OZkHxJoKVf6oUS8vBFY4VZ8zcC8O4Cuz4O5VXbm0MKxMEin464hGnukxYsgFv/GBbP84N30PWB4+9BxH59z4af0Pme9z/Vdn74r3/fqXdR3rZ1X9YzkSpZ+gPAApWLhYa5oGIjo8zNn2cIbs7A6+mYHgMuPhMpPo4SEmPhmD6/ZGpXRJEb8kz4jMCOwgjPHIuC3wZQTCF4BWEIgih41iZ71bUBc/TdZCnN9lkmdEZgRGEegl22DFok7+vGjFEynK4Ar3U+AscfSo1V6Z2dGYEagF4EKOkAqt91Bizrk8j7YttDlzGtnYDG2Ui5dyHE7CK2se7Q8PtszAjMC3Qg8go59EWQVI2gjK68ZGMjk17ZKeaSRTAXJRWI2ZgRmBJ6MQH56vREBtvJ4QC1q8vsxeN1CkxBn4I1CEbJ4n2OCehCXSZ4R6EUgQSo1xVmeXLOHZMqMm3Nq/OR6ysCB4J6lRBPSU382ZwRmBF6LQEZkoyEyrMgNuvVxrW+WBWD9mSC3zy0jpPGh0qo6NVfiRiwPzfaMwIxARKBCZRA7tYCdwIZ+FuW3LDZnYOI3nYCllXrwHa2OhZq0z1Hzz96MwIwAIgCMdje0CbuKk/cDxPxKZpR1C01KFqRyfKMqMjCHmuHQMesZgRmBFyJQ8CQUl540rRBdnzgHboVFZxeAA9kjH2rVK5e+MLknvLLP1ozAjEAVAUFxpaCbnz6vA9bSgy3fO1dbaH5kHH9pJNYYDQ2dO0S1KQ++Wc8IzAhsImDwsTSodnA0yS8nSrWdEGwCt3eCpgysf8Gdf1EUJUajn/N50GY9IzAj8J4INHgzoLaq179CKk+wwGJn4IRdiUUGjrrVNfszAjMChyOQYaaPgqCBNL3yIGkAdU1av1qZf1mzfogVLlE4S6e2mtVgCM16RmBG4NsRcKwpd1Y4XEG4tiIDu1X8zpYKD8uhIKOdw73ddFboqmY1IzAjUCLwJEJSYlSz2gEDeUVNaaxfpSy20NAePBPYhozSOmvvi9byzf6MwIxAPwKBuwAq+2wHvZUqfCMGz8D6ZwvxzzcovVaoty93yI7bCoOilQG33EvPrVOzPyMwI7CJAE+8wjLeqgQaIB6gvJyBq+2xg7jgPpSg5i9Q6gfag+auqFsENv5NwozAjEAnAoabB8ABFgnuUSkADoYNgbJ46fvS/KiJ/+vFN375EvUsMwIzAq9FgEfbZtdrGHNcVYlSwKvsCK/8SVmdhqmoVQZ2qcopluk66KkWcb7NCMwIjCOQAKmtMsCVHxRnwbyV1s882xkXLA5A5E8BWPg94x92IB0Arv4WkRphtErjzY3A1ZFzlhmBGYFXIqAs+UBQidX/NoE3Aex+CfBqx6y/ctDgnrYHhubQjMCMwPMRyFAj9nJBv1B8TL/ZTh78Rf8J/yJaBeAiS7S3ypieizbnRJ93AT3UKsKzMSMwI/BsBAip+iVQGf7iOEsGLzruEpt8xRY6BlWHUNQBZAKVDFGHEPmCN2iznhGYEXg+Ao4xHkX5iiOuQJrA21O4zcBQVvBIoFOqUSIjPW2TNiMwI9CNADGaH0rVTAcQ5WAXSIHeLYCBXvHgrezAk35ieexI7dbszQjMCOxFQIh6zJQSaGk6kAVgEZ1QdsQlDW8S8GNjc3RGYEbgpQgUKKMhTAYGI4E6RssWOc7AGg/mgWkpxFjoKmxUGooLcTZmBGYERhEQZNrBAY4Cd2IHRoU/8hKv3S20K9Y2mdLkrbSE5S4xBmc9IzAj0InAIdQAqAbYVVGRJ4hRtmdg560ybdVxhlztZO/MOtszAv+bESjQq6fvQKyJa09SDf7si1YYiS10qK6+gUVQUhCvHRurtdmaEZgReDoC+g7FHncDPkLSQG37Z2VgEtsyetIcYG/5Z39GYEbgByJQ7W6BVPQzXp/bQie/srDIlYHEOJszAjMC34oAdshNwXefA2/MzO0WuuIOxoo4t9NNOGZ3RuBYBJot7CYhJm0PsyvxCYYr+auzL/oEN7fQj5QnO2uTAhLCm/bu7DQer9yzNSPwQxHQIky6X12DoSfLBy2pH67x4OW3G6PtcsTXeQhRMSkDC0cmQy/0++1skA4GAdjAZkyb9+S7zsXww1xZ34trcNL8pBCpUW+0TsKMwG+MQFmhL9rck39unCAmPuzFNl8OYgcqKGKgRo2Q2QvH+G+VEVX6J48iA3M88RUDAmHI844hg27AKrFQQGNSxC9g0pSDN91BODzLH4hAvrivmm+v4zt0vurLv1FOeCFOiDXHC9sAofrIxkZn32iGo2ayPnZ24FsG3lwMckGQf+kvbWjLqJELuxp0htsB1AtA64MG3/WdblBlFI6MSuYjT/C29JF80EMu+qyP6ghZm0n0fkP9qqM/5Vq56D9l4L9cL+LHELYgZZ8Dqog3rNCg8YGVDdtiYJvFK7UNwE4N5sjqIkuJKZViAvUWfYArxqk4LHj2NQDxPrItPdqWyyhHeLMOytGn/JHY6mPm3G+/6sO+5snxrgjoWkPZj14rKu9lhr1J2GKUb4QJfVXS85peFxoxJiZORsx2Xo62ZJhfT3YG5s/KGqNV3C0F+umXyblSOerGqAjZVz/KxSxMRrkIBexzonfSDpYjIk8E0/yCD0f0ussviByc7IvsivUD2djy7vE9UPGnhyL2T1zi4iplXp9yWKS6kdUjPI0OOGb+YbvMrTMfYhGseJ3xs84GWseW00njfCKpqg8xFVxjZWDmSKOZc2S6x56ciiBNkN+oTPSbGb2bFE+9Z/h6J5ih9A7QKuvJ/2YSbtsClINRBrzRjo30tHLRH8m39OD/O2perFnqCBwNiYCQVGxWTtzcnKflD9FKzmUe8fb8LDowyHGB0d6EqROAewGm9NvsDuSz+qQR6MScYbBnO22hAWIxQ4hKYW2BgguMLaH4evm4cCK3MwAKCOLtBBCfL/yxLTin34w28Gq+8r43rQjRoA6RMnvyBXEgE+Rgq2STfIwH/2+u32V+M73BPGTvXUYHNioyHfud9irj3mG60gK0/tYdUNo7ZeIPlbWc9QJEin+SiS9YVNcF40UHTUKx5GGbiRD/C6TMvgIrcYeX8EdavIhDYpP9kEGD/QJgDtiNgWhH+3KBgsUyLQEMorKwKzrhN6LBAV64/MWvhCBDs0+nQWIWnuXnInAkuryeLNXiMtLw/Yj+oZI/ORCTftaHJ/n1zMeByV0qS/5Z2CpuSac9KzIAE8QcUqYVKAnOk8BroAWyoJt4I6DPVwOrZWlijliUZQMwlWmbDNBeLl94XZB1sU0WiG/o3z5uVATQXkHTL+Mh6y5yHrDFmNSd+FOXsX0mikX+u95yhB/5l/nePgMqf2T87QZx9+d//yOFC/qHStac23vm9EkN/NJ/rJkUy4tgxQvYYma+8Ncm9Qog2zhl4swsvKJbMrDtte2uEAq4N79RkZRDMTGJu89ZW2iefPVlEORdbqC5rQZ4AXKdgzWjwSIdkLXCOHYkMrKT3lrd1JV0fkd1svKG5nc9eUY+TfwNHv9eFdv5PcZlXPit3Fv9pvowdUCxfBeAsbwBRMuiDmQlSgIYW2ImSuKNx9UAMoF+tWz86TSBGfYFYN4VuEVWugaDgZmKeCewrfTFQXu+oe8ToBMLXny4ddb5Nx5iGdCr+blMO3fFA296Yu2xgbpxaRU4ZyaHPGlS5YPqP9I9tvr7RsL5xmK4rYeDzdijLq/R/1yJOSPZHCohR6GR7BGepMPEDLhqE6TEV8EYwEvQ4nX+JOYwTuyxXzKzb6WhQDrwVjKwUjYIVMj0TDDfIHxFRr0tV4H2DIcu6H/g9PvFSZ6wiZYyZF40tbgwrAwstDAQZDxYYs0dkX1WJvgOulTYj/gUQgObA3JIdeuu+S7RxHWhu5p+iPiKwbTQ3+LVyIeenSO8dK7lzzofjPFGysdCrPUSeAlSPqDymmDF69Pry+dVoCbNwG288ZCLiVYAhjyUGrp5/v38XD4WZFqC9Y7MekXbwOkrBWdduIPsC3zCIdY3KDPgMgtjomlieX3lRZvpunCU4QTVWd8yH8fa/spprTwuivvyzmxEG4f1pZi0Pn+3v5mzKzzk48g/XJPfXka+POPIyF/qHI2N9DZ+MJ6jWG9UZFnIYXNr6xttgo9bZe16CWCA9IKHVQFUgRaZmLRL1MzKBDf4hVfoWzMwQGxnXSgG4+cVD6QWy8IEsv0VhLvuceCB+3ZmFoYsgM6yEPTPzrBhpFi14GL8SNBDRt6sbxvd65C1WrkjNltdP9lv/dyz9cI8uM6evYR75n/rOGNDcDT+sx/lu/PKunM79Hdr+KV1DQHWwK4eVmmbTPASmHgFeJV5HbQE7KcDmzwCtPhtt2wA5qSdyDsC9+E3fK/5ciUY8Y+ewQFm13zvuSHtLszE7pSyL0CsL3QwkINiMPfBzObR8KfjA2kjVzqCM+sKWlM/o7sRearb9WdP8gl/91SUccbOC+dY/IENLpafKsXOUQPvmHual65r8kGnvNR/RzPi+IpuylJOwCXWlEHRF+YAXvQNd8ywV+HvwhogvqK+RgZmliY+8eL0eTMoAKZyfli8EO3MvNg2XwOIAnCEwdL/bQFY8brhM+CF2doz77rVThGGqOib+3rmsavKrUFVaFuEI1c97sK1jKi84/RKzNXHVsm11RP7EVpr0n2m5xGNXbuug4tlWHzOq7m1NZT5iQGaHVyX6moNeCqXtFafjlIlGh3ZjJgnm0pSzToJmbYmuIoe94mqBF6CDUUZlRkYmONfF50/gT0cYZmBDbwEMOgCuLUJ3gA+YyYASx3+edETgHj2zHtBfYewijstB/DGB103ZNvlC1trfNmDQGaWjj82Zq1vpvh60N8umiauQMwiOqmOtYMxu78wkwQx8bHZknv6QiTzPqM75I7U2cYzcvQ3ZB75PtIVsp3xdojX7G2lVf6q4nf61PHBl+s6siGsQ2xpexukHd+YqB6VoqvRwy8+3YEbPrDi+ie89eUNz6oEI58/XQBiARhtZt5PvAjwz/84sMVPWaIkMjA8Ql9f1iBo7/jI6LJg64xy1/Nm/tvBYIcDdHD5Aojh0Blf8FiQrfmgC/9cqWVZBIt98pWpRgBBq0rQnUj+EoBgbHiCrHpHH3nkgztC/x+WR7Y6gjG/Sit9Cj2tf62O4GvpD/phs7BsCGVEjc2cD9ocqa/mnE3uzTnz/kQb89ub4ndcHOne00k5Jr7AEfvKrsyoALUeagGccQ7mR0fKwgI02g50flpE8LLwXuBbaOiFcn2EhEEyf8JC7Gb1NUqcd385zxd4mIEJ1AuzMGpGzbYYBmQBmF56CWDaVtqIAfHEBpv8Qsgq90g+xliHLtEgvtVApu2yq+TAEnI88UenIyYze2+t7hG/bIbhEdOr9OR86w9NVvPMNrahyqN/dZvrsiq+kFMoquHotPEJeqkRMO0yQYj1vKczZLWkwUy5kOF5NzBHbOvciwQaD6oEZmTez8AkwQxs2sNmZvL4GAnCtjfHgyt+3aoUfdorICtlw8qib4IYaHkOXpCFy7evtL1w+aym6MOCGdBjUsRNACeJqTmSbflGfV1H2A89xeZAIPgGw3+IPAjg0Jt/MRKHcxoP8JquCeAn5s74H9dLnwR6iFqNhAkscUtN7PFbV8RYPKRi9uXnwQKzam8LfyEXW2jMmoI3AJB3obKw0TjhYyKOLXxYBeHlF/hwVmafTi08K6PWNtrXFuUJ7oeFuouhlXNz91yH9luur6eXwt/SvWP9GbDn7Wzm74Sha200r5Y56+N1+htL9rH4F1u+QrAGt4pHystzdlxuHqTCePiwqzt00GGfD2VjU8A2AathBEEgBr54bZmNY6tcgEtQM+sS7ASvg5l98tsWmraggAz3k593qZA0Zl2AkR8p3fh0+tNAe7stAIQBlduKAAf1CNixcHxCchljeRFrFs0bbe0VPSATkykfXPeNmjt072s3MQsx5rfRUhP020Q+x3qk30MIvlGOC98X/snJTjng1N7121o67vNWxzFKrMWNFFwp3gQiN0xGWNdYzbB8NfEMnQWsxUIlyGNmgDS8YCyvwBzQKV6qsKfMyLYOZgMqzsnYWhOwenJNwKPNUgBMRogDwLZkaUznUSyACz4LFrDw0RJrApRfr0RDZwJuoeNsIK2g8wsdAVrRnn2DbCkHFlaRedCofEx8AdZE4h2t6v7pTu8mxWu0V+zh4h5XZ7r7qveVDjhG4BiwHybrOscySvN4m12u0SdiH44LR76uQ4x1AFoZH32dhzlA8AKkAdjAovoYCznqx58yaqYxXW2jeQblXYxH2thWc0tMJn7Bg0UPsdiEvAIG3LPLePFmwDsVZUeFzqhgZXoLgtAB/UO5kGmU9m4U1YL3qEm3B7JR8VK3C3xoegZYrUElhLi6jGli+M7C47UhiP9Eqa7BEw5onhED8udrlel7urh2e3MeXTDo660hmontbpi0ZNVTbhxFD9d1Wdg2pt0QiJE9OW5rhaAEVlxGgMUYH1ZRSQC7WiPuUAD4/7xfV1xIAinIdMbx6KCvedljwGNrkoPoExFo21m1WmjTbxJlyOXZL8BnZ08XeXKB7t4WHeHLXGsb5MoeRuLm0tJXIbSO+lUJv7nTi+cDE7YT6zO8cmPqa/pZqnaITfJor9fLc+Eact3KJ36tn9HHtUc/Kl7oU4k1E1iJJRn0Qcj+H2Ziafks6vYbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3038",
    "data-name": "Rectangle 3038",
    width: 209.853,
    height: 66.601,
    rx: 23.798,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3137",
    "data-name": "Rectangle 3137",
    width: 9.635,
    height: 19.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3236",
    "data-name": "Rectangle 3236",
    width: 9.635,
    height: 26.388,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3335",
    "data-name": "Rectangle 3335",
    width: 9.635,
    height: 32.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3434",
    "data-name": "Rectangle 3434",
    width: 9.635,
    height: 36.547,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    "data-name": "Path 7764",
    d: "M8.077,52.366V71.494h8.486V52.366a15.206,15.206,0,1,1,30.412,0V71.494h8.485V52.366a23.692,23.692,0,1,0-47.384,0",
    transform: "translate(-8.077 -28.674)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3611",
    "data-name": "Rectangle 3611",
    width: 61.095,
    height: 61.095,
    rx: 13.961,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4275",
    "data-name": "Group 4275",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(216.361 211.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4229",
    "data-name": "Group 4229",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2888",
    "data-name": "Rectangle 2888",
    width: 78.745,
    height: 73.636,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4232",
    "data-name": "Group 4232",
    transform: "translate(176.721 276.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4231",
    "data-name": "Group 4231",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2889",
    "data-name": "Rectangle 2889",
    width: 158.023,
    height: 14.842,
    transform: "translate(0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4234",
    "data-name": "Group 4234",
    transform: "translate(82.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4233",
    "data-name": "Group 4233",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2890",
    "data-name": "Rectangle 2890",
    width: 347.039,
    height: 254.607,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4244",
    "data-name": "Group 4244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4243",
    "data-name": "Group 4243",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7734",
    "data-name": "Path 7734",
    d: "M410.066,245.631H134.484a25.136,25.136,0,0,1-25.136-25.136V38.007A25.137,25.137,0,0,1,134.484,12.87H410.066A25.137,25.137,0,0,1,435.2,38.007V220.494a25.136,25.136,0,0,1-25.136,25.136",
    transform: "translate(-16.543 -1.947)",
    fill: "#f6fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    d: "M400.139,60.433H143.416a16.968,16.968,0,0,1,0-33.936H400.139a16.968,16.968,0,1,1,0,33.936",
    transform: "translate(-19.129 -4.009)",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M370.109,171.585H173.446a47,47,0,0,1-47-47v-.576a47,47,0,0,1,47-47H370.109a47,47,0,0,1,47,47v.576a47,47,0,0,1-47,47",
    transform: "translate(-19.129 -11.651)",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M228.067,161.277H176.992a34.743,34.743,0,1,1,0-69.486h51.075a34.743,34.743,0,0,1,0,69.486",
    transform: "translate(-21.52 -13.886)",
    fill: "#a6d3f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M236.017,262.576H157.071a30.624,30.624,0,1,1,0-61.248h78.946a30.624,30.624,0,1,1,0,61.248",
    transform: "translate(-19.129 -30.458)",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M244,236.531H152.686a14.346,14.346,0,1,1,0-28.693H244a14.346,14.346,0,1,1,0,28.693",
    transform: "translate(-20.928 -31.442)",
    fill: "#ef8597"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M413.3,262.576H334.357a30.624,30.624,0,1,1,0-61.248H413.3a30.624,30.624,0,0,1,0,61.248",
    transform: "translate(-45.95 -30.458)",
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M421.287,236.531H329.971a14.346,14.346,0,1,1,0-28.693h91.316a14.346,14.346,0,1,1,0,28.693",
    transform: "translate(-47.749 -31.442)",
    fill: "#a6d3f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7742",
    "data-name": "Path 7742",
    d: "M153.791,44.539a6.271,6.271,0,1,1-6.27-6.27,6.271,6.271,0,0,1,6.27,6.27",
    transform: "translate(-21.369 -5.789)",
    fill: "#ef8597"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7743",
    "data-name": "Path 7743",
    d: "M366.707,160.434a6.271,6.271,0,1,1-6.27-6.27,6.271,6.271,0,0,1,6.27,6.27",
    transform: "translate(-53.579 -23.322)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7744",
    "data-name": "Path 7744",
    d: "M386.694,160.434a6.271,6.271,0,1,1-6.27-6.27,6.271,6.271,0,0,1,6.27,6.27",
    transform: "translate(-56.603 -23.322)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7745",
    "data-name": "Path 7745",
    d: "M237.7,50.809H171.06a6.271,6.271,0,0,1,0-12.541H237.7a6.271,6.271,0,0,1,0,12.541",
    transform: "translate(-24.93 -5.789)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7746",
    "data-name": "Path 7746",
    d: "M399.685,116.73h-73.95a2.141,2.141,0,0,0,0,4.282h73.95a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-48.954 -17.659)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7747",
    "data-name": "Path 7747",
    d: "M238.225,249.267h-73.95a2.141,2.141,0,0,0,0,4.282h73.95a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-24.528 -37.71)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M246.042,257.858H153.065a2.141,2.141,0,0,0,0,4.282h92.977a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-22.832 -39.01)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M392.071,249.267H318.12a2.141,2.141,0,0,0,0,4.282h73.95a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-47.802 -37.71)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M411.973,257.858H319a2.141,2.141,0,0,0,0,4.282h92.977a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-47.935 -39.01)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M404.64,105.317H318.474a2.494,2.494,0,1,0,0,4.989H404.64a2.494,2.494,0,1,0,0-4.989",
    transform: "translate(-47.802 -15.933)",
    fill: "#75c5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M410.9,125.493H309.654a2.141,2.141,0,0,0,0,4.282H410.9a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-46.522 -18.985)",
    fill: "#cfd8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M393.25,134.256H334.959a2.141,2.141,0,0,0,0,4.282H393.25a2.141,2.141,0,0,0,0-4.282",
    transform: "translate(-50.35 -20.311)",
    fill: "#cfd8e4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4258",
    "data-name": "Group 4258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4257",
    "data-name": "Group 4257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4256",
    "data-name": "Group 4256",
    transform: "translate(16.165 142.596)",
    opacity: 0.52,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4255",
    "data-name": "Group 4255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4254",
    "data-name": "Group 4254",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4253",
    "data-name": "Group 4253",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4252",
    "data-name": "Group 4252",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4251",
    "data-name": "Group 4251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4250",
    "data-name": "Group 4250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4249",
    "data-name": "Group 4249",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3014",
    "data-name": "Rectangle 3014",
    width: 202.877,
    height: 70.885,
    transform: "translate(-0.277 -0.38)",
    fill: "url(#pattern)"
  })))))))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4260",
    "data-name": "Group 4260",
    transform: "translate(12.484 139.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4259",
    "data-name": "Group 4259",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7759",
    "data-name": "Path 7759",
    d: "M224.563,164.665h0Z",
    transform: "translate(-14.709 -164.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 209.854,
    height: 63.22,
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3019",
    "data-name": "Rectangle 3019",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 63.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3020",
    "data-name": "Rectangle 3020",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 63.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3021",
    "data-name": "Rectangle 3021",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 63.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3022",
    "data-name": "Rectangle 3022",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 63.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3023",
    "data-name": "Rectangle 3023",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 63.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3024",
    "data-name": "Rectangle 3024",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3025",
    "data-name": "Rectangle 3025",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3026",
    "data-name": "Rectangle 3026",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.414)",
    fill: "#fefeff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3027",
    "data-name": "Rectangle 3027",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.586)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3028",
    "data-name": "Rectangle 3028",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.756)",
    fill: "#fefdfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3029",
    "data-name": "Rectangle 3029",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 64.927)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3030",
    "data-name": "Rectangle 3030",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.097)",
    fill: "#fbfafb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3031",
    "data-name": "Rectangle 3031",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.268)",
    fill: "#f9f7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3032",
    "data-name": "Rectangle 3032",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.439)",
    fill: "#f7f4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3033",
    "data-name": "Rectangle 3033",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.61)",
    fill: "#f4f1f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3034",
    "data-name": "Rectangle 3034",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.781)",
    fill: "#f1edf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3035",
    "data-name": "Rectangle 3035",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 65.951)",
    fill: "#ede8ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3036",
    "data-name": "Rectangle 3036",
    width: 209.854,
    height: 0.171,
    transform: "translate(0 66.122)",
    fill: "#e8e2e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3037",
    "data-name": "Rectangle 3037",
    width: 209.854,
    height: 0.307,
    transform: "translate(-0.001 66.292)",
    fill: "#e8e2e8"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4262",
    "data-name": "Group 4262",
    transform: "translate(150.578 170.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4261",
    "data-name": "Group 4261",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    "data-name": "Path 7760",
    d: "M187.053,201.333h0Z",
    transform: "translate(-177.418 -201.332)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3039",
    "data-name": "Rectangle 3039",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.001)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.031)",
    fill: "#cd86b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.061)",
    fill: "#cc84b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3042",
    "data-name": "Rectangle 3042",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.091)",
    fill: "#cc83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3043",
    "data-name": "Rectangle 3043",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.121)",
    fill: "#cb82b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3044",
    "data-name": "Rectangle 3044",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.152)",
    fill: "#cb81b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3045",
    "data-name": "Rectangle 3045",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.182)",
    fill: "#ca80b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3046",
    "data-name": "Rectangle 3046",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.212)",
    fill: "#ca7eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3047",
    "data-name": "Rectangle 3047",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.242)",
    fill: "#c97db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3048",
    "data-name": "Rectangle 3048",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.272)",
    fill: "#c97cb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3049",
    "data-name": "Rectangle 3049",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.303)",
    fill: "#c97bb1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3050",
    "data-name": "Rectangle 3050",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.333)",
    fill: "#c87ab1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3051",
    "data-name": "Rectangle 3051",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.363)",
    fill: "#c879b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3052",
    "data-name": "Rectangle 3052",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.394)",
    fill: "#c777af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3053",
    "data-name": "Rectangle 3053",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.424)",
    fill: "#c776af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3054",
    "data-name": "Rectangle 3054",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.454)",
    fill: "#c775ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3055",
    "data-name": "Rectangle 3055",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.484)",
    fill: "#c674ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3056",
    "data-name": "Rectangle 3056",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.514)",
    fill: "#c673ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3057",
    "data-name": "Rectangle 3057",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.545)",
    fill: "#c672ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3058",
    "data-name": "Rectangle 3058",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.575)",
    fill: "#c571ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.605)",
    fill: "#c570ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3060",
    "data-name": "Rectangle 3060",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.635)",
    fill: "#c56faa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3061",
    "data-name": "Rectangle 3061",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.665)",
    fill: "#c46ea9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3062",
    "data-name": "Rectangle 3062",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.696)",
    fill: "#c46da9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3063",
    "data-name": "Rectangle 3063",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.726)",
    fill: "#c46ca8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3064",
    "data-name": "Rectangle 3064",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.756)",
    fill: "#c36ba8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3065",
    "data-name": "Rectangle 3065",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.787)",
    fill: "#c36aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3066",
    "data-name": "Rectangle 3066",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.816)",
    fill: "#c269a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3067",
    "data-name": "Rectangle 3067",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.847)",
    fill: "#c268a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3068",
    "data-name": "Rectangle 3068",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.877)",
    fill: "#c267a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3069",
    "data-name": "Rectangle 3069",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.907)",
    fill: "#c166a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3070",
    "data-name": "Rectangle 3070",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.938)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3071",
    "data-name": "Rectangle 3071",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.968)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3072",
    "data-name": "Rectangle 3072",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 0.998)",
    fill: "#c164a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3073",
    "data-name": "Rectangle 3073",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.028)",
    fill: "#c063a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3074",
    "data-name": "Rectangle 3074",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.058)",
    fill: "#c062a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3075",
    "data-name": "Rectangle 3075",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.089)",
    fill: "#c061a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3076",
    "data-name": "Rectangle 3076",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.119)",
    fill: "#bf60a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3077",
    "data-name": "Rectangle 3077",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.149)",
    fill: "#bf5fa1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3078",
    "data-name": "Rectangle 3078",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.18)",
    fill: "#bf5fa0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3079",
    "data-name": "Rectangle 3079",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.209)",
    fill: "#bf5ea0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3080",
    "data-name": "Rectangle 3080",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.24)",
    fill: "#bf5d9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3081",
    "data-name": "Rectangle 3081",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.27)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3082",
    "data-name": "Rectangle 3082",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.3)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3083",
    "data-name": "Rectangle 3083",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.331)",
    fill: "#be5b9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3084",
    "data-name": "Rectangle 3084",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.36)",
    fill: "#be5a9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3085",
    "data-name": "Rectangle 3085",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.391)",
    fill: "#bd599d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3086",
    "data-name": "Rectangle 3086",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.421)",
    fill: "#bd589d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3087",
    "data-name": "Rectangle 3087",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.451)",
    fill: "#bd589c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3088",
    "data-name": "Rectangle 3088",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.482)",
    fill: "#bd579c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3089",
    "data-name": "Rectangle 3089",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.512)",
    fill: "#bc569c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090",
    "data-name": "Rectangle 3090",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.542)",
    fill: "#bc569b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3091",
    "data-name": "Rectangle 3091",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.573)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3092",
    "data-name": "Rectangle 3092",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.602)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3093",
    "data-name": "Rectangle 3093",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.633)",
    fill: "#bc549a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3094",
    "data-name": "Rectangle 3094",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.663)",
    fill: "#bc539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3095",
    "data-name": "Rectangle 3095",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.693)",
    fill: "#bb539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3096",
    "data-name": "Rectangle 3096",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.724)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3097",
    "data-name": "Rectangle 3097",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.753)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3098",
    "data-name": "Rectangle 3098",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.784)",
    fill: "#bb5199"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3099",
    "data-name": "Rectangle 3099",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.814)",
    fill: "#bb5198"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3100",
    "data-name": "Rectangle 3100",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.844)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3101",
    "data-name": "Rectangle 3101",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.875)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3102",
    "data-name": "Rectangle 3102",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.905)",
    fill: "#ba4f98"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3103",
    "data-name": "Rectangle 3103",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.935)",
    fill: "#ba4f97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3104",
    "data-name": "Rectangle 3104",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.966)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3105",
    "data-name": "Rectangle 3105",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 1.995)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3106",
    "data-name": "Rectangle 3106",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.026)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3107",
    "data-name": "Rectangle 3107",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.056)",
    fill: "#ba4d97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3108",
    "data-name": "Rectangle 3108",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.086)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3109",
    "data-name": "Rectangle 3109",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.117)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3110",
    "data-name": "Rectangle 3110",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.146)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3111",
    "data-name": "Rectangle 3111",
    width: 9.634,
    height: 0.031,
    transform: "translate(0 2.177)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3112",
    "data-name": "Rectangle 3112",
    width: 9.634,
    height: 14.825,
    transform: "translate(0 2.208)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3113",
    "data-name": "Rectangle 3113",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.033)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3114",
    "data-name": "Rectangle 3114",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.14)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3115",
    "data-name": "Rectangle 3115",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.247)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3116",
    "data-name": "Rectangle 3116",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.354)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3117",
    "data-name": "Rectangle 3117",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.461)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3118",
    "data-name": "Rectangle 3118",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.568)",
    fill: "#b84b96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3119",
    "data-name": "Rectangle 3119",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.675)",
    fill: "#b84b95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3120",
    "data-name": "Rectangle 3120",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.781)",
    fill: "#b74a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3121",
    "data-name": "Rectangle 3121",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.888)",
    fill: "#b64a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3122",
    "data-name": "Rectangle 3122",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 17.994)",
    fill: "#b64994"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3123",
    "data-name": "Rectangle 3123",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.101)",
    fill: "#b54894"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.208)",
    fill: "#b44793"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.315)",
    fill: "#b34693"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.422)",
    fill: "#b24592"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3127",
    "data-name": "Rectangle 3127",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.529)",
    fill: "#b14492"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.636)",
    fill: "#b04391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.743)",
    fill: "#af4291"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3130",
    "data-name": "Rectangle 3130",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.849)",
    fill: "#ad4090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3131",
    "data-name": "Rectangle 3131",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 18.956)",
    fill: "#ac3f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3132",
    "data-name": "Rectangle 3132",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 19.063)",
    fill: "#ab3d8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3133",
    "data-name": "Rectangle 3133",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 19.17)",
    fill: "#a93c8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3134",
    "data-name": "Rectangle 3134",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 19.277)",
    fill: "#a83a8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3135",
    "data-name": "Rectangle 3135",
    width: 9.634,
    height: 0.107,
    transform: "translate(0 19.384)",
    fill: "#a6398c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3136",
    "data-name": "Rectangle 3136",
    width: 9.634,
    height: 0.09,
    transform: "translate(0 19.491)",
    fill: "#a6398c"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4264",
    "data-name": "Group 4264",
    transform: "translate(163.981 164.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4263",
    "data-name": "Group 4263",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    "data-name": "Path 7761",
    d: "M202.846,193.311h0Z",
    transform: "translate(-193.211 -193.311)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3138",
    "data-name": "Rectangle 3138",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3139",
    "data-name": "Rectangle 3139",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.041)",
    fill: "#cd86b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3140",
    "data-name": "Rectangle 3140",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.081)",
    fill: "#cc84b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3141",
    "data-name": "Rectangle 3141",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.122)",
    fill: "#cc83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3142",
    "data-name": "Rectangle 3142",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.163)",
    fill: "#cb82b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3143",
    "data-name": "Rectangle 3143",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.204)",
    fill: "#cb81b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3144",
    "data-name": "Rectangle 3144",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.244)",
    fill: "#ca80b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3145",
    "data-name": "Rectangle 3145",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.285)",
    fill: "#ca7eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3146",
    "data-name": "Rectangle 3146",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.326)",
    fill: "#c97db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3147",
    "data-name": "Rectangle 3147",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.367)",
    fill: "#c97cb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3148",
    "data-name": "Rectangle 3148",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.407)",
    fill: "#c97bb1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3149",
    "data-name": "Rectangle 3149",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.448)",
    fill: "#c87ab1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3150",
    "data-name": "Rectangle 3150",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.489)",
    fill: "#c879b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3151",
    "data-name": "Rectangle 3151",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.53)",
    fill: "#c777af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3152",
    "data-name": "Rectangle 3152",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.57)",
    fill: "#c776af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3153",
    "data-name": "Rectangle 3153",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.611)",
    fill: "#c775ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3154",
    "data-name": "Rectangle 3154",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.652)",
    fill: "#c674ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3155",
    "data-name": "Rectangle 3155",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.693)",
    fill: "#c673ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3156",
    "data-name": "Rectangle 3156",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.733)",
    fill: "#c672ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3157",
    "data-name": "Rectangle 3157",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.774)",
    fill: "#c571ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3158",
    "data-name": "Rectangle 3158",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.815)",
    fill: "#c570ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3159",
    "data-name": "Rectangle 3159",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.856)",
    fill: "#c56faa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3160",
    "data-name": "Rectangle 3160",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.896)",
    fill: "#c46ea9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3161",
    "data-name": "Rectangle 3161",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.937)",
    fill: "#c46da9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3162",
    "data-name": "Rectangle 3162",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 0.978)",
    fill: "#c46ca8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3163",
    "data-name": "Rectangle 3163",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.018)",
    fill: "#c36ba8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3164",
    "data-name": "Rectangle 3164",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.059)",
    fill: "#c36aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3165",
    "data-name": "Rectangle 3165",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.1)",
    fill: "#c269a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3166",
    "data-name": "Rectangle 3166",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.141)",
    fill: "#c268a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3167",
    "data-name": "Rectangle 3167",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.181)",
    fill: "#c267a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3168",
    "data-name": "Rectangle 3168",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.222)",
    fill: "#c166a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3169",
    "data-name": "Rectangle 3169",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.263)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3170",
    "data-name": "Rectangle 3170",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.304)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3171",
    "data-name": "Rectangle 3171",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.344)",
    fill: "#c164a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3172",
    "data-name": "Rectangle 3172",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.385)",
    fill: "#c063a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3173",
    "data-name": "Rectangle 3173",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.426)",
    fill: "#c062a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3174",
    "data-name": "Rectangle 3174",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.467)",
    fill: "#c061a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3175",
    "data-name": "Rectangle 3175",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.507)",
    fill: "#bf60a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3176",
    "data-name": "Rectangle 3176",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.548)",
    fill: "#bf5fa1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3177",
    "data-name": "Rectangle 3177",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.589)",
    fill: "#bf5fa0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3178",
    "data-name": "Rectangle 3178",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.63)",
    fill: "#bf5ea0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.67)",
    fill: "#bf5d9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3180",
    "data-name": "Rectangle 3180",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.711)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.752)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.792)",
    fill: "#be5b9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.833)",
    fill: "#be5a9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3184",
    "data-name": "Rectangle 3184",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.874)",
    fill: "#bd599d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3185",
    "data-name": "Rectangle 3185",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.915)",
    fill: "#bd589d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3186",
    "data-name": "Rectangle 3186",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.955)",
    fill: "#bd589c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3187",
    "data-name": "Rectangle 3187",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 1.996)",
    fill: "#bd579c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3188",
    "data-name": "Rectangle 3188",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.037)",
    fill: "#bc569c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3189",
    "data-name": "Rectangle 3189",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.078)",
    fill: "#bc569b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3190",
    "data-name": "Rectangle 3190",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.118)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3191",
    "data-name": "Rectangle 3191",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.159)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3192",
    "data-name": "Rectangle 3192",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.2)",
    fill: "#bc549a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3193",
    "data-name": "Rectangle 3193",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.241)",
    fill: "#bc539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.281)",
    fill: "#bb539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3195",
    "data-name": "Rectangle 3195",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.322)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3196",
    "data-name": "Rectangle 3196",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.363)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3197",
    "data-name": "Rectangle 3197",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.404)",
    fill: "#bb5199"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3198",
    "data-name": "Rectangle 3198",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.444)",
    fill: "#bb5198"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3199",
    "data-name": "Rectangle 3199",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.485)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3200",
    "data-name": "Rectangle 3200",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.526)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3201",
    "data-name": "Rectangle 3201",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.567)",
    fill: "#ba4f98"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3202",
    "data-name": "Rectangle 3202",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.607)",
    fill: "#ba4f97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3203",
    "data-name": "Rectangle 3203",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.648)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3204",
    "data-name": "Rectangle 3204",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.689)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3205",
    "data-name": "Rectangle 3205",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.729)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3206",
    "data-name": "Rectangle 3206",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.77)",
    fill: "#ba4d97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3207",
    "data-name": "Rectangle 3207",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.811)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3208",
    "data-name": "Rectangle 3208",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.852)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3209",
    "data-name": "Rectangle 3209",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.892)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3210",
    "data-name": "Rectangle 3210",
    width: 9.634,
    height: 0.041,
    transform: "translate(0.001 2.933)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3211",
    "data-name": "Rectangle 3211",
    width: 9.634,
    height: 19.98,
    transform: "translate(0.001 2.974)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 22.954)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.099)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3214",
    "data-name": "Rectangle 3214",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.242)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3215",
    "data-name": "Rectangle 3215",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.386)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3216",
    "data-name": "Rectangle 3216",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.531)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3217",
    "data-name": "Rectangle 3217",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.674)",
    fill: "#b84b96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3218",
    "data-name": "Rectangle 3218",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.818)",
    fill: "#b84b95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3219",
    "data-name": "Rectangle 3219",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 23.963)",
    fill: "#b74a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3220",
    "data-name": "Rectangle 3220",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.106)",
    fill: "#b64a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3221",
    "data-name": "Rectangle 3221",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.25)",
    fill: "#b64994"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3222",
    "data-name": "Rectangle 3222",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.395)",
    fill: "#b54894"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.538)",
    fill: "#b44793"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3224",
    "data-name": "Rectangle 3224",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.682)",
    fill: "#b34693"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3225",
    "data-name": "Rectangle 3225",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.827)",
    fill: "#b24592"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3226",
    "data-name": "Rectangle 3226",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 24.971)",
    fill: "#b14492"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3227",
    "data-name": "Rectangle 3227",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.114)",
    fill: "#b04391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3228",
    "data-name": "Rectangle 3228",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.259)",
    fill: "#af4291"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3229",
    "data-name": "Rectangle 3229",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.403)",
    fill: "#ad4090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3230",
    "data-name": "Rectangle 3230",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.546)",
    fill: "#ac3f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3231",
    "data-name": "Rectangle 3231",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.691)",
    fill: "#ab3d8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3232",
    "data-name": "Rectangle 3232",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.835)",
    fill: "#a93c8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3233",
    "data-name": "Rectangle 3233",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 25.978)",
    fill: "#a83a8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3234",
    "data-name": "Rectangle 3234",
    width: 9.634,
    height: 0.144,
    transform: "translate(0.001 26.123)",
    fill: "#a6398c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3235",
    "data-name": "Rectangle 3235",
    width: 9.634,
    height: 0.121,
    transform: "translate(0 26.267)",
    fill: "#a6398c"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4266",
    "data-name": "Group 4266",
    transform: "translate(177.385 158.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4265",
    "data-name": "Group 4265",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    "data-name": "Path 7762",
    d: "M218.639,186.579h0Z",
    transform: "translate(-209.004 -186.579)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3237",
    "data-name": "Rectangle 3237",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.001)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3238",
    "data-name": "Rectangle 3238",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.05)",
    fill: "#cd86b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3239",
    "data-name": "Rectangle 3239",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.099)",
    fill: "#cc84b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3240",
    "data-name": "Rectangle 3240",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.149)",
    fill: "#cc83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3241",
    "data-name": "Rectangle 3241",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.199)",
    fill: "#cb82b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3242",
    "data-name": "Rectangle 3242",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.249)",
    fill: "#cb81b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3243",
    "data-name": "Rectangle 3243",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.298)",
    fill: "#ca80b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3244",
    "data-name": "Rectangle 3244",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.347)",
    fill: "#ca7eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3245",
    "data-name": "Rectangle 3245",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.397)",
    fill: "#c97db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3246",
    "data-name": "Rectangle 3246",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.446)",
    fill: "#c97cb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3247",
    "data-name": "Rectangle 3247",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.496)",
    fill: "#c97bb1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3248",
    "data-name": "Rectangle 3248",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.546)",
    fill: "#c87ab1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3249",
    "data-name": "Rectangle 3249",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.595)",
    fill: "#c879b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3250",
    "data-name": "Rectangle 3250",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.645)",
    fill: "#c777af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3251",
    "data-name": "Rectangle 3251",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.694)",
    fill: "#c776af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3252",
    "data-name": "Rectangle 3252",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.743)",
    fill: "#c775ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.794)",
    fill: "#c674ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.843)",
    fill: "#c673ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3255",
    "data-name": "Rectangle 3255",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.893)",
    fill: "#c672ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3256",
    "data-name": "Rectangle 3256",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.942)",
    fill: "#c571ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 0.991)",
    fill: "#c570ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3258",
    "data-name": "Rectangle 3258",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.041)",
    fill: "#c56faa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.091)",
    fill: "#c46ea9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3260",
    "data-name": "Rectangle 3260",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.141)",
    fill: "#c46da9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3261",
    "data-name": "Rectangle 3261",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.19)",
    fill: "#c46ca8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3262",
    "data-name": "Rectangle 3262",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.239)",
    fill: "#c36ba8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3263",
    "data-name": "Rectangle 3263",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.289)",
    fill: "#c36aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3264",
    "data-name": "Rectangle 3264",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.338)",
    fill: "#c269a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3265",
    "data-name": "Rectangle 3265",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.389)",
    fill: "#c268a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3266",
    "data-name": "Rectangle 3266",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.438)",
    fill: "#c267a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3267",
    "data-name": "Rectangle 3267",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.487)",
    fill: "#c166a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3268",
    "data-name": "Rectangle 3268",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.537)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3269",
    "data-name": "Rectangle 3269",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.586)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3270",
    "data-name": "Rectangle 3270",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.636)",
    fill: "#c164a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3271",
    "data-name": "Rectangle 3271",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.686)",
    fill: "#c063a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3272",
    "data-name": "Rectangle 3272",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.735)",
    fill: "#c062a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3273",
    "data-name": "Rectangle 3273",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.785)",
    fill: "#c061a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3274",
    "data-name": "Rectangle 3274",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.834)",
    fill: "#bf60a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3275",
    "data-name": "Rectangle 3275",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.883)",
    fill: "#bf5fa1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.933)",
    fill: "#bf5fa0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3277",
    "data-name": "Rectangle 3277",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 1.983)",
    fill: "#bf5ea0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3278",
    "data-name": "Rectangle 3278",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.033)",
    fill: "#bf5d9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3279",
    "data-name": "Rectangle 3279",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.082)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3280",
    "data-name": "Rectangle 3280",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.131)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3281",
    "data-name": "Rectangle 3281",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.181)",
    fill: "#be5b9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.23)",
    fill: "#be5a9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3283",
    "data-name": "Rectangle 3283",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.281)",
    fill: "#bd599d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3284",
    "data-name": "Rectangle 3284",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.33)",
    fill: "#bd589d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3285",
    "data-name": "Rectangle 3285",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.379)",
    fill: "#bd589c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3286",
    "data-name": "Rectangle 3286",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.429)",
    fill: "#bd579c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3287",
    "data-name": "Rectangle 3287",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.478)",
    fill: "#bc569c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3288",
    "data-name": "Rectangle 3288",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.528)",
    fill: "#bc569b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3289",
    "data-name": "Rectangle 3289",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.578)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3290",
    "data-name": "Rectangle 3290",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.627)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3291",
    "data-name": "Rectangle 3291",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.677)",
    fill: "#bc549a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3292",
    "data-name": "Rectangle 3292",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.726)",
    fill: "#bc539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3293",
    "data-name": "Rectangle 3293",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.776)",
    fill: "#bb539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3294",
    "data-name": "Rectangle 3294",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.825)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3295",
    "data-name": "Rectangle 3295",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.875)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3296",
    "data-name": "Rectangle 3296",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.925)",
    fill: "#bb5199"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3297",
    "data-name": "Rectangle 3297",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 2.974)",
    fill: "#bb5198"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.024)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3299",
    "data-name": "Rectangle 3299",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.073)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3300",
    "data-name": "Rectangle 3300",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.122)",
    fill: "#ba4f98"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3301",
    "data-name": "Rectangle 3301",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.173)",
    fill: "#ba4f97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3302",
    "data-name": "Rectangle 3302",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.222)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3303",
    "data-name": "Rectangle 3303",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.271)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3304",
    "data-name": "Rectangle 3304",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.321)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3305",
    "data-name": "Rectangle 3305",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.37)",
    fill: "#ba4d97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3306",
    "data-name": "Rectangle 3306",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.42)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3307",
    "data-name": "Rectangle 3307",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.47)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3308",
    "data-name": "Rectangle 3308",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.519)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3309",
    "data-name": "Rectangle 3309",
    width: 9.634,
    height: 0.049,
    transform: "translate(0.001 3.569)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3310",
    "data-name": "Rectangle 3310",
    width: 9.634,
    height: 24.306,
    transform: "translate(0.001 3.618)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3311",
    "data-name": "Rectangle 3311",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 27.925)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3312",
    "data-name": "Rectangle 3312",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.1)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3313",
    "data-name": "Rectangle 3313",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.275)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3314",
    "data-name": "Rectangle 3314",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.451)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3315",
    "data-name": "Rectangle 3315",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.626)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3316",
    "data-name": "Rectangle 3316",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.801)",
    fill: "#b84b96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3317",
    "data-name": "Rectangle 3317",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 28.976)",
    fill: "#b84b95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3318",
    "data-name": "Rectangle 3318",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 29.152)",
    fill: "#b74a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3319",
    "data-name": "Rectangle 3319",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 29.327)",
    fill: "#b64a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3320",
    "data-name": "Rectangle 3320",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 29.501)",
    fill: "#b64994"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3321",
    "data-name": "Rectangle 3321",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 29.677)",
    fill: "#b54894"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3322",
    "data-name": "Rectangle 3322",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 29.852)",
    fill: "#b44793"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3323",
    "data-name": "Rectangle 3323",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.028)",
    fill: "#b34693"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3324",
    "data-name": "Rectangle 3324",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.202)",
    fill: "#b24592"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3325",
    "data-name": "Rectangle 3325",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.378)",
    fill: "#b14492"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3326",
    "data-name": "Rectangle 3326",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.553)",
    fill: "#b04391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3327",
    "data-name": "Rectangle 3327",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.728)",
    fill: "#af4291"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3328",
    "data-name": "Rectangle 3328",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 30.903)",
    fill: "#ad4090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3329",
    "data-name": "Rectangle 3329",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 31.078)",
    fill: "#ac3f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3330",
    "data-name": "Rectangle 3330",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 31.254)",
    fill: "#ab3d8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3331",
    "data-name": "Rectangle 3331",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 31.429)",
    fill: "#a93c8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3332",
    "data-name": "Rectangle 3332",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 31.605)",
    fill: "#a83a8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3333",
    "data-name": "Rectangle 3333",
    width: 9.634,
    height: 0.175,
    transform: "translate(0.001 31.779)",
    fill: "#a6398c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3334",
    "data-name": "Rectangle 3334",
    width: 9.634,
    height: 0.148,
    transform: "translate(0.001 31.954)",
    fill: "#a6398c"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4268",
    "data-name": "Group 4268",
    transform: "translate(190.79 153.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4267",
    "data-name": "Group 4267",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    "data-name": "Path 7763",
    d: "M234.432,181.341h0Z",
    transform: "translate(-224.798 -181.341)",
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3336",
    "data-name": "Rectangle 3336",
    width: 9.634,
    height: 0.056,
    fill: "#cd87b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3337",
    "data-name": "Rectangle 3337",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.057)",
    fill: "#cd86b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3338",
    "data-name": "Rectangle 3338",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.113)",
    fill: "#cc84b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3339",
    "data-name": "Rectangle 3339",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.17)",
    fill: "#cc83b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3340",
    "data-name": "Rectangle 3340",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.226)",
    fill: "#cb82b6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3341",
    "data-name": "Rectangle 3341",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.283)",
    fill: "#cb81b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3342",
    "data-name": "Rectangle 3342",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.339)",
    fill: "#ca80b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3343",
    "data-name": "Rectangle 3343",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.396)",
    fill: "#ca7eb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3344",
    "data-name": "Rectangle 3344",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.452)",
    fill: "#c97db3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3345",
    "data-name": "Rectangle 3345",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.508)",
    fill: "#c97cb2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3346",
    "data-name": "Rectangle 3346",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.564)",
    fill: "#c97bb1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3347",
    "data-name": "Rectangle 3347",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.621)",
    fill: "#c87ab1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3348",
    "data-name": "Rectangle 3348",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.677)",
    fill: "#c879b0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3349",
    "data-name": "Rectangle 3349",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.734)",
    fill: "#c777af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3350",
    "data-name": "Rectangle 3350",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.79)",
    fill: "#c776af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3351",
    "data-name": "Rectangle 3351",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.846)",
    fill: "#c775ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3352",
    "data-name": "Rectangle 3352",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.903)",
    fill: "#c674ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3353",
    "data-name": "Rectangle 3353",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 0.959)",
    fill: "#c673ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3354",
    "data-name": "Rectangle 3354",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.016)",
    fill: "#c672ac"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3355",
    "data-name": "Rectangle 3355",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.072)",
    fill: "#c571ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3356",
    "data-name": "Rectangle 3356",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.129)",
    fill: "#c570ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3357",
    "data-name": "Rectangle 3357",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.185)",
    fill: "#c56faa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3358",
    "data-name": "Rectangle 3358",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.242)",
    fill: "#c46ea9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3359",
    "data-name": "Rectangle 3359",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.298)",
    fill: "#c46da9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3360",
    "data-name": "Rectangle 3360",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.355)",
    fill: "#c46ca8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3361",
    "data-name": "Rectangle 3361",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.411)",
    fill: "#c36ba8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3362",
    "data-name": "Rectangle 3362",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.467)",
    fill: "#c36aa7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3363",
    "data-name": "Rectangle 3363",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.523)",
    fill: "#c269a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3364",
    "data-name": "Rectangle 3364",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.58)",
    fill: "#c268a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3365",
    "data-name": "Rectangle 3365",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.636)",
    fill: "#c267a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3366",
    "data-name": "Rectangle 3366",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.693)",
    fill: "#c166a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3367",
    "data-name": "Rectangle 3367",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.749)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3368",
    "data-name": "Rectangle 3368",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.806)",
    fill: "#c165a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3369",
    "data-name": "Rectangle 3369",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.862)",
    fill: "#c164a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3370",
    "data-name": "Rectangle 3370",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.919)",
    fill: "#c063a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3371",
    "data-name": "Rectangle 3371",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 1.975)",
    fill: "#c062a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3372",
    "data-name": "Rectangle 3372",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.032)",
    fill: "#c061a2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3373",
    "data-name": "Rectangle 3373",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.088)",
    fill: "#bf60a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3374",
    "data-name": "Rectangle 3374",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.145)",
    fill: "#bf5fa1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3375",
    "data-name": "Rectangle 3375",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.201)",
    fill: "#bf5fa0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3376",
    "data-name": "Rectangle 3376",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.257)",
    fill: "#bf5ea0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3377",
    "data-name": "Rectangle 3377",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.314)",
    fill: "#bf5d9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3378",
    "data-name": "Rectangle 3378",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.37)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3379",
    "data-name": "Rectangle 3379",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.426)",
    fill: "#be5c9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3380",
    "data-name": "Rectangle 3380",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.482)",
    fill: "#be5b9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3381",
    "data-name": "Rectangle 3381",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.539)",
    fill: "#be5a9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3382",
    "data-name": "Rectangle 3382",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.595)",
    fill: "#bd599d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3383",
    "data-name": "Rectangle 3383",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.652)",
    fill: "#bd589d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3384",
    "data-name": "Rectangle 3384",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.708)",
    fill: "#bd589c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3385",
    "data-name": "Rectangle 3385",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.765)",
    fill: "#bd579c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3386",
    "data-name": "Rectangle 3386",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.821)",
    fill: "#bc569c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3387",
    "data-name": "Rectangle 3387",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.878)",
    fill: "#bc569b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3388",
    "data-name": "Rectangle 3388",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.934)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3389",
    "data-name": "Rectangle 3389",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 2.991)",
    fill: "#bc559b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3390",
    "data-name": "Rectangle 3390",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.047)",
    fill: "#bc549a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3391",
    "data-name": "Rectangle 3391",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.104)",
    fill: "#bc539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3392",
    "data-name": "Rectangle 3392",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.16)",
    fill: "#bb539a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3393",
    "data-name": "Rectangle 3393",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.217)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3394",
    "data-name": "Rectangle 3394",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.273)",
    fill: "#bb5299"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3395",
    "data-name": "Rectangle 3395",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.33)",
    fill: "#bb5199"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3396",
    "data-name": "Rectangle 3396",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.386)",
    fill: "#bb5198"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3397",
    "data-name": "Rectangle 3397",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.442)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3398",
    "data-name": "Rectangle 3398",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.498)",
    fill: "#ba5098"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3399",
    "data-name": "Rectangle 3399",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.555)",
    fill: "#ba4f98"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3400",
    "data-name": "Rectangle 3400",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.611)",
    fill: "#ba4f97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3401",
    "data-name": "Rectangle 3401",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.668)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3402",
    "data-name": "Rectangle 3402",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.724)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3403",
    "data-name": "Rectangle 3403",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.78)",
    fill: "#ba4e97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3404",
    "data-name": "Rectangle 3404",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.837)",
    fill: "#ba4d97"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3405",
    "data-name": "Rectangle 3405",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.893)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3406",
    "data-name": "Rectangle 3406",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 3.95)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3407",
    "data-name": "Rectangle 3407",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 4.006)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3408",
    "data-name": "Rectangle 3408",
    width: 9.634,
    height: 0.056,
    transform: "translate(0 4.063)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3409",
    "data-name": "Rectangle 3409",
    width: 9.634,
    height: 27.673,
    transform: "translate(0 4.118)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3410",
    "data-name": "Rectangle 3410",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 31.792)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3411",
    "data-name": "Rectangle 3411",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 31.992)",
    fill: "#ba4d96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3412",
    "data-name": "Rectangle 3412",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 32.191)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3413",
    "data-name": "Rectangle 3413",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 32.39)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3414",
    "data-name": "Rectangle 3414",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 32.59)",
    fill: "#b94c96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3415",
    "data-name": "Rectangle 3415",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 32.789)",
    fill: "#b84b96"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3416",
    "data-name": "Rectangle 3416",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 32.989)",
    fill: "#b84b95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3417",
    "data-name": "Rectangle 3417",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 33.188)",
    fill: "#b74a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3418",
    "data-name": "Rectangle 3418",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 33.388)",
    fill: "#b64a95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3419",
    "data-name": "Rectangle 3419",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 33.587)",
    fill: "#b64994"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3420",
    "data-name": "Rectangle 3420",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 33.787)",
    fill: "#b54894"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3421",
    "data-name": "Rectangle 3421",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 33.986)",
    fill: "#b44793"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 34.185)",
    fill: "#b34693"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3423",
    "data-name": "Rectangle 3423",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 34.385)",
    fill: "#b24592"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3424",
    "data-name": "Rectangle 3424",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 34.584)",
    fill: "#b14492"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3425",
    "data-name": "Rectangle 3425",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 34.784)",
    fill: "#b04391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3426",
    "data-name": "Rectangle 3426",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 34.983)",
    fill: "#af4291"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3427",
    "data-name": "Rectangle 3427",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 35.183)",
    fill: "#ad4090"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3428",
    "data-name": "Rectangle 3428",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 35.382)",
    fill: "#ac3f8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3429",
    "data-name": "Rectangle 3429",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 35.582)",
    fill: "#ab3d8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3430",
    "data-name": "Rectangle 3430",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 35.781)",
    fill: "#a93c8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3431",
    "data-name": "Rectangle 3431",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 35.98)",
    fill: "#a83a8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3432",
    "data-name": "Rectangle 3432",
    width: 9.634,
    height: 0.199,
    transform: "translate(0 36.18)",
    fill: "#a6398c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3433",
    "data-name": "Rectangle 3433",
    width: 9.634,
    height: 0.169,
    transform: "translate(0 36.379)",
    fill: "#a6398c"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4270",
    "data-name": "Group 4270",
    transform: "translate(6.855 24.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4269",
    "data-name": "Group 4269",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3435",
    "data-name": "Rectangle 3435",
    width: 47.384,
    height: 38.687,
    transform: "translate(0 4.133)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3436",
    "data-name": "Rectangle 3436",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 4.087)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3437",
    "data-name": "Rectangle 3437",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 4.042)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3438",
    "data-name": "Rectangle 3438",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.997)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3439",
    "data-name": "Rectangle 3439",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.951)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3440",
    "data-name": "Rectangle 3440",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.905)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3441",
    "data-name": "Rectangle 3441",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.859)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3442",
    "data-name": "Rectangle 3442",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.813)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3443",
    "data-name": "Rectangle 3443",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.767)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3444",
    "data-name": "Rectangle 3444",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.722)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3445",
    "data-name": "Rectangle 3445",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.676)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3446",
    "data-name": "Rectangle 3446",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.63)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3447",
    "data-name": "Rectangle 3447",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.584)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3448",
    "data-name": "Rectangle 3448",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.538)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3449",
    "data-name": "Rectangle 3449",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.492)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3450",
    "data-name": "Rectangle 3450",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.448)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3451",
    "data-name": "Rectangle 3451",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.402)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3452",
    "data-name": "Rectangle 3452",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.356)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3453",
    "data-name": "Rectangle 3453",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.31)",
    fill: "#241e4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3454",
    "data-name": "Rectangle 3454",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.264)",
    fill: "#241e4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3455",
    "data-name": "Rectangle 3455",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.218)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3456",
    "data-name": "Rectangle 3456",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.173)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3457",
    "data-name": "Rectangle 3457",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.127)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3458",
    "data-name": "Rectangle 3458",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.081)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3459",
    "data-name": "Rectangle 3459",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 3.035)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3460",
    "data-name": "Rectangle 3460",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.989)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3461",
    "data-name": "Rectangle 3461",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.943)",
    fill: "#251f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3462",
    "data-name": "Rectangle 3462",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.898)",
    fill: "#251f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3463",
    "data-name": "Rectangle 3463",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.853)",
    fill: "#251f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3464",
    "data-name": "Rectangle 3464",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.807)",
    fill: "#25204d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3465",
    "data-name": "Rectangle 3465",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.761)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3466",
    "data-name": "Rectangle 3466",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.715)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3467",
    "data-name": "Rectangle 3467",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.669)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.623)",
    fill: "#25204f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3469",
    "data-name": "Rectangle 3469",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.578)",
    fill: "#25204f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3470",
    "data-name": "Rectangle 3470",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.532)",
    fill: "#252150"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3471",
    "data-name": "Rectangle 3471",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.486)",
    fill: "#252150"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3472",
    "data-name": "Rectangle 3472",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.44)",
    fill: "#262151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473",
    "data-name": "Rectangle 3473",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.394)",
    fill: "#262151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474",
    "data-name": "Rectangle 3474",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.348)",
    fill: "#262152"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3475",
    "data-name": "Rectangle 3475",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.303)",
    fill: "#262252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3476",
    "data-name": "Rectangle 3476",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.257)",
    fill: "#262253"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3477",
    "data-name": "Rectangle 3477",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.212)",
    fill: "#262253"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3478",
    "data-name": "Rectangle 3478",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.166)",
    fill: "#262354"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3479",
    "data-name": "Rectangle 3479",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.12)",
    fill: "#262354"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3480",
    "data-name": "Rectangle 3480",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.074)",
    fill: "#272355"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3481",
    "data-name": "Rectangle 3481",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 2.028)",
    fill: "#272356"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3482",
    "data-name": "Rectangle 3482",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.983)",
    fill: "#272456"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3483",
    "data-name": "Rectangle 3483",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.937)",
    fill: "#272457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3484",
    "data-name": "Rectangle 3484",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.891)",
    fill: "#272458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3485",
    "data-name": "Rectangle 3485",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.845)",
    fill: "#272559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3486",
    "data-name": "Rectangle 3486",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.799)",
    fill: "#272559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3487",
    "data-name": "Rectangle 3487",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.753)",
    fill: "#28255a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3488",
    "data-name": "Rectangle 3488",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.708)",
    fill: "#28265b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3489",
    "data-name": "Rectangle 3489",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.662)",
    fill: "#28265c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3490",
    "data-name": "Rectangle 3490",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.617)",
    fill: "#28265d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3491",
    "data-name": "Rectangle 3491",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.571)",
    fill: "#28275e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3492",
    "data-name": "Rectangle 3492",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.525)",
    fill: "#28275f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3493",
    "data-name": "Rectangle 3493",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.479)",
    fill: "#292860"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3494",
    "data-name": "Rectangle 3494",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.433)",
    fill: "#292861"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3495",
    "data-name": "Rectangle 3495",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.388)",
    fill: "#292962"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3496",
    "data-name": "Rectangle 3496",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.342)",
    fill: "#292963"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3497",
    "data-name": "Rectangle 3497",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.296)",
    fill: "#292964"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3498",
    "data-name": "Rectangle 3498",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.25)",
    fill: "#292a65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3499",
    "data-name": "Rectangle 3499",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.204)",
    fill: "#2a2a66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3500",
    "data-name": "Rectangle 3500",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.158)",
    fill: "#2a2b67"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3501",
    "data-name": "Rectangle 3501",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.113)",
    fill: "#2a2b69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3502",
    "data-name": "Rectangle 3502",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.067)",
    fill: "#2a2c6a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3503",
    "data-name": "Rectangle 3503",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 1.022)",
    fill: "#2a2c6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3504",
    "data-name": "Rectangle 3504",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.976)",
    fill: "#2a2d6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3505",
    "data-name": "Rectangle 3505",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.93)",
    fill: "#2a2e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3506",
    "data-name": "Rectangle 3506",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.884)",
    fill: "#2b2e6f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3507",
    "data-name": "Rectangle 3507",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.839)",
    fill: "#2b2f71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508",
    "data-name": "Rectangle 3508",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.793)",
    fill: "#2b2f72"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3509",
    "data-name": "Rectangle 3509",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.747)",
    fill: "#2b3074"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3510",
    "data-name": "Rectangle 3510",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.701)",
    fill: "#2b3176"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3511",
    "data-name": "Rectangle 3511",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.655)",
    fill: "#2b3177"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3512",
    "data-name": "Rectangle 3512",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.609)",
    fill: "#2b3279"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3513",
    "data-name": "Rectangle 3513",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.564)",
    fill: "#2b327b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3514",
    "data-name": "Rectangle 3514",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.518)",
    fill: "#2b337d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3515",
    "data-name": "Rectangle 3515",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.472)",
    fill: "#2c347e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3516",
    "data-name": "Rectangle 3516",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.427)",
    fill: "#2c3581"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.381)",
    fill: "#2c3683"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.335)",
    fill: "#2c3685"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.289)",
    fill: "#2c3787"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.244)",
    fill: "#2b388a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3521",
    "data-name": "Rectangle 3521",
    width: 47.384,
    height: 0.046,
    transform: "translate(0 0.198)",
    fill: "#2b3a8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3522",
    "data-name": "Rectangle 3522",
    width: 47.384,
    height: 0.198,
    transform: "translate(0 0)",
    fill: "#2b3a8f"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4272",
    "data-name": "Group 4272",
    transform: "translate(0 59.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4271",
    "data-name": "Group 4271",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3523",
    "data-name": "Rectangle 3523",
    width: 61.094,
    height: 55.197,
    transform: "translate(0 5.898)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3524",
    "data-name": "Rectangle 3524",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.832)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3525",
    "data-name": "Rectangle 3525",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.767)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3526",
    "data-name": "Rectangle 3526",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.702)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3527",
    "data-name": "Rectangle 3527",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.636)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3528",
    "data-name": "Rectangle 3528",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.571)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3529",
    "data-name": "Rectangle 3529",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.506)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3530",
    "data-name": "Rectangle 3530",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.44)",
    fill: "#241e49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3531",
    "data-name": "Rectangle 3531",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.375)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3532",
    "data-name": "Rectangle 3532",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.31)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3533",
    "data-name": "Rectangle 3533",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.244)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3534",
    "data-name": "Rectangle 3534",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.179)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3535",
    "data-name": "Rectangle 3535",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.114)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3536",
    "data-name": "Rectangle 3536",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 5.049)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3537",
    "data-name": "Rectangle 3537",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.984)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3538",
    "data-name": "Rectangle 3538",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.918)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3539",
    "data-name": "Rectangle 3539",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.853)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3540",
    "data-name": "Rectangle 3540",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.788)",
    fill: "#241e4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3541",
    "data-name": "Rectangle 3541",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.722)",
    fill: "#241e4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3542",
    "data-name": "Rectangle 3542",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.657)",
    fill: "#241e4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3543",
    "data-name": "Rectangle 3543",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.592)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3544",
    "data-name": "Rectangle 3544",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.526)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3545",
    "data-name": "Rectangle 3545",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.461)",
    fill: "#241f4b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3546",
    "data-name": "Rectangle 3546",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.396)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3547",
    "data-name": "Rectangle 3547",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.33)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3548",
    "data-name": "Rectangle 3548",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.265)",
    fill: "#241f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3549",
    "data-name": "Rectangle 3549",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.199)",
    fill: "#251f4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3550",
    "data-name": "Rectangle 3550",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.134)",
    fill: "#251f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3551",
    "data-name": "Rectangle 3551",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.069)",
    fill: "#251f4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3552",
    "data-name": "Rectangle 3552",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 4.004)",
    fill: "#25204d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3553",
    "data-name": "Rectangle 3553",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.939)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3554",
    "data-name": "Rectangle 3554",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.874)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3555",
    "data-name": "Rectangle 3555",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.808)",
    fill: "#25204e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3556",
    "data-name": "Rectangle 3556",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.743)",
    fill: "#25204f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3557",
    "data-name": "Rectangle 3557",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.677)",
    fill: "#25204f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3558",
    "data-name": "Rectangle 3558",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.612)",
    fill: "#252150"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3559",
    "data-name": "Rectangle 3559",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.547)",
    fill: "#252150"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3560",
    "data-name": "Rectangle 3560",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.481)",
    fill: "#262151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3561",
    "data-name": "Rectangle 3561",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.416)",
    fill: "#262151"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3562",
    "data-name": "Rectangle 3562",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.351)",
    fill: "#262152"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3563",
    "data-name": "Rectangle 3563",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.285)",
    fill: "#262252"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3564",
    "data-name": "Rectangle 3564",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.22)",
    fill: "#262253"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3565",
    "data-name": "Rectangle 3565",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.155)",
    fill: "#262253"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3566",
    "data-name": "Rectangle 3566",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.089)",
    fill: "#262354"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3567",
    "data-name": "Rectangle 3567",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 3.024)",
    fill: "#262354"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3568",
    "data-name": "Rectangle 3568",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.959)",
    fill: "#272355"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3569",
    "data-name": "Rectangle 3569",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.894)",
    fill: "#272356"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3570",
    "data-name": "Rectangle 3570",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.829)",
    fill: "#272456"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3571",
    "data-name": "Rectangle 3571",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.763)",
    fill: "#272457"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3572",
    "data-name": "Rectangle 3572",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.698)",
    fill: "#272458"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.633)",
    fill: "#272559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3574",
    "data-name": "Rectangle 3574",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.567)",
    fill: "#272559"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.502)",
    fill: "#28255a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.437)",
    fill: "#28265b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3577",
    "data-name": "Rectangle 3577",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.371)",
    fill: "#28265c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3578",
    "data-name": "Rectangle 3578",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.306)",
    fill: "#28265d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3579",
    "data-name": "Rectangle 3579",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.241)",
    fill: "#28275e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.175)",
    fill: "#28275f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.11)",
    fill: "#292860"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 2.045)",
    fill: "#292861"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3583",
    "data-name": "Rectangle 3583",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.979)",
    fill: "#292962"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3584",
    "data-name": "Rectangle 3584",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.915)",
    fill: "#292963"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.849)",
    fill: "#292964"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3586",
    "data-name": "Rectangle 3586",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.784)",
    fill: "#292a65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3587",
    "data-name": "Rectangle 3587",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.719)",
    fill: "#2a2a66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3588",
    "data-name": "Rectangle 3588",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.653)",
    fill: "#2a2b67"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3589",
    "data-name": "Rectangle 3589",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.588)",
    fill: "#2a2b69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3590",
    "data-name": "Rectangle 3590",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.523)",
    fill: "#2a2c6a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3591",
    "data-name": "Rectangle 3591",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.457)",
    fill: "#2a2c6b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3592",
    "data-name": "Rectangle 3592",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.392)",
    fill: "#2a2d6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3593",
    "data-name": "Rectangle 3593",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.327)",
    fill: "#2a2e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3594",
    "data-name": "Rectangle 3594",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.261)",
    fill: "#2b2e6f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3595",
    "data-name": "Rectangle 3595",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.196)",
    fill: "#2b2f71"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3596",
    "data-name": "Rectangle 3596",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.13)",
    fill: "#2b2f72"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3597",
    "data-name": "Rectangle 3597",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1.065)",
    fill: "#2b3074"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3598",
    "data-name": "Rectangle 3598",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 1)",
    fill: "#2b3176"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3599",
    "data-name": "Rectangle 3599",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.934)",
    fill: "#2b3177"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3600",
    "data-name": "Rectangle 3600",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.87)",
    fill: "#2b3279"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3601",
    "data-name": "Rectangle 3601",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.805)",
    fill: "#2b327b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3602",
    "data-name": "Rectangle 3602",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.739)",
    fill: "#2b337d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3603",
    "data-name": "Rectangle 3603",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.674)",
    fill: "#2c347e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3604",
    "data-name": "Rectangle 3604",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.609)",
    fill: "#2c3581"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3605",
    "data-name": "Rectangle 3605",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.543)",
    fill: "#2c3683"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3606",
    "data-name": "Rectangle 3606",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.478)",
    fill: "#2c3685"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3607",
    "data-name": "Rectangle 3607",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.412)",
    fill: "#2c3787"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3608",
    "data-name": "Rectangle 3608",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.347)",
    fill: "#2b388a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3609",
    "data-name": "Rectangle 3609",
    width: 61.094,
    height: 0.065,
    transform: "translate(0 0.282)",
    fill: "#2b3a8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3610",
    "data-name": "Rectangle 3610",
    width: 61.094,
    height: 0.282,
    fill: "#2b3a8f"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4274",
    "data-name": "Group 4274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4273",
    "data-name": "Group 4273",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    "data-name": "Path 7765",
    d: "M42.724,97.5A8.191,8.191,0,1,0,30.7,104.737v8.275a3.834,3.834,0,0,0,7.667,0v-8.275A8.186,8.186,0,0,0,42.724,97.5",
    transform: "translate(-3.985 -13.511)",
    fill: "#fff"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "SEO",
    transform: "translate(41.813 190.096)",
    fill: "#241e49",
    fontSize: 47,
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEO")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebTools);
export default __webpack_public_path__ + "static/media/webTools.77519be9fba86b68244870c2d0a6f899.svg";
export { ForwardRef as ReactComponent };